import Cart from "cart-store";

// Adds every checked size to the cart in one request, then opens the cart the
// same way Venue's product-form.js does after a single-variant add.
class AwSizeMultiselect extends HTMLElement {
  #connected = false;

  connectedCallback() {
    if (this.#connected) return;
    this.#connected = true;

    this.checkboxes = [...this.querySelectorAll('input[type="checkbox"]')];
    this.button = this.querySelector("[data-aw-size-add]");
    this.stagedAction = this.button.querySelector("staged-action");

    this.addEventListener("change", () => this.#syncButton());
    this.button.addEventListener("click", () => this.#add());
    this.#syncButton();
  }

  #checked() {
    return this.checkboxes.filter((checkbox) => checkbox.checked);
  }

  // Cart.add flattens "properties[...]" keys into a properties object
  // (assets/cart-store.js addVariantsToCart), matching what FormData produces.
  #lineItem(variantId) {
    const item = { id: variantId, quantity: 1 };
    if (this.hasAttribute("data-show-quantity-picker")) {
      item["properties[_show_quantity_picker]"] = "true";
    }
    return item;
  }

  #syncButton() {
    this.button.disabled = this.#checked().length === 0;
  }

  async #add() {
    const items = this.#checked().map((checkbox) => this.#lineItem(checkbox.value));
    if (items.length === 0) return;

    this.#removeError();
    this.button.disabled = true;
    await this.stagedAction.setState("DOING");

    // Cart.add throws an Error carrying Shopify's description when
    // /cart/add.js rejects the request (e.g. a size sold out meanwhile).
    // Show it above the button and let the customer adjust and retry.
    try {
      await Cart.add(items);
    } catch (error) {
      this.#renderError(error.message);
      await this.stagedAction.setState("IDLE");
      this.#syncButton();
      return;
    }

    if (this.dataset.redirectOnAdd) {
      window.location.href = this.dataset.redirectOnAdd;
      return;
    }

    await this.stagedAction.setState("DONE");
    this.checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.#syncButton();
    await Cart.resetVariantsBeingAdded();
    this.#openCart();
  }

  #openCart() {
    const cart = document.querySelector(".modal--cart, .popup--cart-notification");
    if (!cart) return;
    if (!cart.shown) {
      cart.open();
    } else if (cart.interval) {
      cart.interval.reset();
      cart.interval.start();
    }
  }

  #removeError() {
    this.querySelector(".errors")?.remove();
  }

  #renderError(message) {
    const error = document.createElement("div");
    error.classList.add("errors", "qty-error", "u-small");
    error.textContent = message;
    this.button.before(error);
  }
}

customElements.define("aw-size-multiselect", AwSizeMultiselect);
